/* Ciberia homepage sections */
(function () {
  if (window.__cbInit) return;
  window.__cbInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- toast ---------- */
  var toast;
  function showToast(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cb-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span></span><a href="' + root + 'cart">View bag</a>';
    toast.firstChild.textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  /* ---------- add to cart (opens the theme's own cart drawer) ---------- */
  function addItems(items) {
    var drawer = document.querySelector('cart-drawer');
    var notif = document.querySelector('cart-notification');
    var target = drawer || notif;
    var sections = target && target.getSectionsToRender
      ? target.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
        return j;
      });
    }).then(function (j) {
      if (target && target.renderContents && j.sections) {
        if (drawer) drawer.classList.remove('is-empty');
        var first = (j.items && j.items[0]) || j;
        target.renderContents({ id: first.id, key: first.key, sections: j.sections });
        j.__opened = true;
      } else {
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) { el.textContent = cart.item_count; });
        });
      }
      return j;
    });
  }
  window.cbAddItems = addItems;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    addItems([{ id: Number(btn.dataset.cbQuickAdd), quantity: 1 }])
      .then(function (j) { if (!j.__opened) showToast('Added to bag'); })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- bundle builder ---------- */
  function initBundle(sec) {
    if (sec.__cb) return; sec.__cb = true;
    var dataEl = sec.querySelector('[data-cb-bundle-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var picks = [null, null, null];
    var thongSize = null;

    function sizesOf(p) {
      var seen = [];
      p.variants.forEach(function (v) { if (seen.indexOf(v.option1) === -1) seen.push(v.option1); });
      return seen;
    }
    function variantFor(p, size) {
      if (p.variants.length === 1) return p.variants[0].available ? p.variants[0] : null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].option1 === size && p.variants[i].available) return p.variants[i];
      }
      return null;
    }
    function needsSize(list) { return list.some(function (p) { return p.variants.length > 1; }); }

    sec.querySelectorAll('.cb-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        sec.querySelectorAll('.cb-tab').forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        sec.querySelectorAll('[data-cb-panel]').forEach(function (p) { p.hidden = p.dataset.cbPanel !== t.dataset.cbTab; });
      });
    });

    var slotsEl = sec.querySelector('[data-cb-slots]');
    var thongOpts = sec.querySelector('[data-cb-thong-opts]');
    var thongSizeEl = sec.querySelector('[data-cb-thong-size]');
    var cta3 = sec.querySelector('[data-cb-cta-3]');

    if (thongOpts) {
      data.thongs.forEach(function (p, idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cb-opt';
        b.innerHTML = '<img alt="" loading="lazy"><span></span>';
        b.querySelector('img').src = p.img; b.querySelector('span').textContent = p.label;
        b.addEventListener('click', function () {
          var i = picks.indexOf(null);
          if (i < 0) { picks.shift(); picks.push(idx); } else { picks[i] = idx; }
          render3();
        });
        thongOpts.appendChild(b);
      });
      if (needsSize(data.thongs) && thongSizeEl) {
        thongSizeEl.hidden = false;
        var row = thongSizeEl.querySelector('.cb-size');
        sizesOf(data.thongs[0]).forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = s; b.dataset.v = s;
          b.addEventListener('click', function () { thongSize = s; render3(); });
          row.appendChild(b);
        });
      }
    }

    function render3() {
      if (!slotsEl) return;
      slotsEl.innerHTML = '';
      picks.forEach(function (idx, i) {
        var b = document.createElement('button');
        b.type = 'button';
        var p = idx === null ? null : data.thongs[idx];
        b.className = 'cb-slot' + (p ? ' is-full' : '');
        b.setAttribute('aria-label', p ? 'Remove ' + p.label : 'Empty slot ' + (i + 1));
        if (p) { b.innerHTML = '<img alt=""><span></span>'; b.querySelector('img').src = p.img; b.querySelector('span').textContent = p.label; }
        else { b.innerHTML = '<span></span>'; b.querySelector('span').textContent = data.slotLabel + ' ' + (i + 1); }
        b.addEventListener('click', function () { picks[i] = null; render3(); });
        slotsEl.appendChild(b);
      });
      if (thongSizeEl) thongSizeEl.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === thongSize)); });
      var n = picks.filter(function (x) { return x !== null; }).length;
      var sizeMissing = needsSize(data.thongs) && !thongSize;
      cta3.disabled = n < 3 || sizeMissing;
      cta3.textContent = n < 3 ? data.pickMore.replace('[n]', 3 - n) : (sizeMissing ? data.selectSize : data.cta3);
    }

    if (cta3) cta3.addEventListener('click', function () {
      var counts = {};
      for (var i = 0; i < picks.length; i++) {
        var v = variantFor(data.thongs[picks[i]], thongSize);
        if (!v) { showToast(data.thongs[picks[i]].label + ' is sold out in that size'); return; }
        counts[v.id] = (counts[v.id] || 0) + 1;
      }
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      cta3.disabled = true;
      addItems(items).then(function (j) { if (!j.__opened) showToast('Bundle added to bag'); })
        .catch(function (err) { showToast(err.message); })
        .finally(function () { render3(); });
    });
    render3();

    var set = { bra: 0, thong: 0, braSize: null, thongSize: null };
    var braOpts = sec.querySelector('[data-cb-bra-opts]');
    var setThongOpts = sec.querySelector('[data-cb-set-thong-opts]');
    var ctaSet = sec.querySelector('[data-cb-cta-set]');

    function buildOpts(el, list, key) {
      list.forEach(function (p, idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cb-opt';
        b.innerHTML = '<img alt="" loading="lazy"><span></span>';
        b.querySelector('img').src = p.img; b.querySelector('span').textContent = p.label;
        b.addEventListener('click', function () { set[key] = idx; set[key + 'Size'] = null; renderSet(); });
        el.appendChild(b);
      });
    }
    function buildSizes(el, p, key) {
      el.innerHTML = '';
      el.parentElement.hidden = p.variants.length < 2;
      if (p.variants.length < 2) return;
      sizesOf(p).forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = s; b.dataset.v = s;
        var avail = p.variants.some(function (v) { return v.option1 === s && v.available; });
        if (!avail) b.disabled = true;
        b.setAttribute('aria-pressed', String(set[key] === s));
        b.addEventListener('click', function () { set[key] = s; renderSet(); });
        el.appendChild(b);
      });
    }
    function renderSet() {
      if (!braOpts || !data.bras.length || !data.setThongs.length) return;
      var bra = data.bras[set.bra], th = data.setThongs[set.thong];
      braOpts.querySelectorAll('.cb-opt').forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === set.bra)); });
      setThongOpts.querySelectorAll('.cb-opt').forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === set.thong)); });
      sec.querySelector('[data-cb-set-bra-img]').src = bra.img;
      sec.querySelector('[data-cb-set-bra-cap]').textContent = bra.label;
      sec.querySelector('[data-cb-set-thong-img]').src = th.img;
      sec.querySelector('[data-cb-set-thong-cap]').textContent = th.label;
      buildSizes(sec.querySelector('[data-cb-bra-size]'), bra, 'braSize');
      buildSizes(sec.querySelector('[data-cb-thong-size-set]'), th, 'thongSize');
      var missing = (bra.variants.length > 1 && !set.braSize) || (th.variants.length > 1 && !set.thongSize);
      ctaSet.disabled = missing;
      ctaSet.textContent = missing ? data.selectSize : data.ctaSet;
    }
    if (braOpts) {
      buildOpts(braOpts, data.bras, 'bra');
      buildOpts(setThongOpts, data.setThongs, 'thong');
      ctaSet.addEventListener('click', function () {
        var bv = variantFor(data.bras[set.bra], set.braSize);
        var tv = variantFor(data.setThongs[set.thong], set.thongSize);
        if (!bv || !tv) { showToast('Sold out in that size'); return; }
        ctaSet.disabled = true;
        addItems([{ id: bv.id, quantity: 1 }, { id: tv.id, quantity: 1 }])
          .then(function (j) { if (!j.__opened) showToast('Set added to bag'); })
          .catch(function (err) { showToast(err.message); })
          .finally(renderSet);
      });
      renderSet();
    }
  }

  /* ---------- styled by you ---------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.35 }) : null;

  function initSby(sec) {
    if (sec.__cb) return; sec.__cb = true;
    var track = sec.querySelector('.cb-sby__track');
    sec.querySelectorAll('[data-cb-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.75 * Number(b.dataset.cbDir), behavior: 'smooth' });
      });
    });
    if (vio && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sec.querySelectorAll('video').forEach(function (v) { vio.observe(v); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cb-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-cb-sby]').forEach(initSby);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* ===== Mobile menu – keep drawer open while tapping inside it =====
   The accordions themselves are pure CSS (checkbox + label), no JS needed. */
(function () {
  if (window.__cbMenuInit) return;
  window.__cbMenuInit = true;

  /* The theme closes the drawer when focus "leaves" it. On iPhone that
     happens on normal taps inside the menu, so ignore it inside the drawer. */
  document.addEventListener('focusout', function (e) {
    var d = document.getElementById('Details-menu-drawer-container');
    if (d && d.hasAttribute('open') && d.contains(e.target)) e.stopPropagation();
  }, true);

  /* Back button: start with the menu closed */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var d = document.getElementById('Details-menu-drawer-container');
    if (!d) return;
    d.removeAttribute('open');
    d.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
  });
})();

/* ===== Desktop mega menu ===== */
(function () {
  if (window.__cbDmInit) return;
  window.__cbDmInit = true;

  var openItem = null, tOpen, tClose, lastTouch = false;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function place(item) {
    var panel = item.querySelector('.cb-dm__panel');
    if (!panel) return;
    var wrap = document.getElementById('header-wrapper-custom') || item.closest('header');
    panel.hidden = false;
    var op = panel.offsetParent || document.body;
    var r = op.getBoundingClientRect(), w = wrap.getBoundingClientRect();
    panel.style.top = (w.bottom - r.top) + 'px';
    panel.style.left = (-r.left) + 'px';
    panel.style.width = document.documentElement.clientWidth + 'px';
  }
  function close() {
    if (!openItem) return;
    var p = openItem.querySelector('.cb-dm__panel');
    if (p) p.hidden = true;
    openItem.classList.remove('is-open');
    var a = openItem.querySelector('.cb-dm__top');
    if (a) a.setAttribute('aria-expanded', 'false');
    openItem = null;
  }
  function open(item) {
    if (openItem === item) return;
    close();
    openItem = item;
    place(item);
    item.classList.add('is-open');
    var a = item.querySelector('.cb-dm__top');
    if (a) a.setAttribute('aria-expanded', 'true');
  }
  function itemOf(el) {
    return el && el.closest ? el.closest('[data-cb-dm] .cb-dm__item') : null;
  }

  document.addEventListener('pointerdown', function (e) { lastTouch = e.pointerType === 'touch'; }, true);

  /* hover (mouse only) */
  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var item = itemOf(e.target);
    if (!item) return;
    clearTimeout(tClose);
    clearTimeout(tOpen);
    if (item.classList.contains('has-panel')) {
      tOpen = setTimeout(function () { open(item); }, openItem ? 0 : 120);
    } else {
      close();
    }
  });
  document.addEventListener('mouseout', function (e) {
    if (!canHover.matches) return;
    var from = itemOf(e.target);
    if (!from) return;
    if (itemOf(e.relatedTarget) === from) return;
    clearTimeout(tOpen);
    tClose = setTimeout(close, 250);
  });

  /* touch and click: first tap opens, second tap follows the link */
  document.addEventListener('click', function (e) {
    var top = e.target.closest && e.target.closest('[data-cb-dm] .cb-dm__top');
    if (top) {
      var item = top.parentElement;
      if (item.classList.contains('has-panel') && openItem !== item) {
        e.preventDefault();
        open(item);
      }
      return;
    }
    if (openItem && !openItem.contains(e.target)) close();
  });

  /* keyboard */
  document.addEventListener('focusin', function (e) {
    if (lastTouch) return;
    var item = itemOf(e.target);
    if (item) {
      if (item.classList.contains('has-panel')) open(item); else close();
    } else if (openItem && !openItem.contains(e.target)) {
      close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openItem) return;
    var a = openItem.querySelector('.cb-dm__top');
    close();
    if (a) a.focus();
  });

  window.addEventListener('scroll', function () { if (openItem) close(); }, { passive: true });
  window.addEventListener('resize', function () { if (openItem) place(openItem); });
})();